import * as React from "react";

function Ai(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M16 3.634a4.292 4.292 0 00-3.636 3.635 4.292 4.292 0 00-3.636-3.635A4.292 4.292 0 0012.364 0 4.292 4.292 0 0016 3.634zM12.364 7.99a3.42 3.42 0 01-2.905 2.902 3.42 3.42 0 012.905 2.903 3.42 3.42 0 012.904-2.903 3.42 3.42 0 01-2.904-2.902zM5.103.73a3.42 3.42 0 01-2.905 2.903 3.42 3.42 0 012.905 2.903 3.42 3.42 0 012.904-2.903A3.42 3.42 0 015.103.731zm4.734 7.875L2.93 15.497A1.725 1.725 0 011.718 16c-.434 0-.88-.171-1.212-.503a1.703 1.703 0 010-2.423l6.895-6.891a1.725 1.725 0 011.212-.503c.435 0 .88.171 1.212.503.675.674.675 1.76 0 2.423h.012zm-.64-1.212a.54.54 0 00-.172-.4.574.574 0 00-.4-.171.557.557 0 00-.4.171l-1.441 1.44.812.812 1.44-1.44a.573.573 0 00.172-.4h-.012v-.012z"
        fill="url(#prefix__paint0_linear_4976_162628)"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_4976_162628"
          x1={9.802}
          y1={-11.8}
          x2={30.091}
          y2={-7.29}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#076698" />
          <stop offset={0.516} stopColor="#054567" />
          <stop offset={1} stopColor="#022232" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Ai;
